(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('facility-pharmacy', {
            parent: 'entity',
            url: '/facility-pharmacy',
            data: {
                authorities: [],
                pageTitle: 'FacilityPharmacy'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/facility-pharmacy/list/facility-pharmacy.html',
                    controller: 'FacilityPharmacyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PHARMACY];
                    return Auth.loadActionsAccess(actions).$promise;
                }],
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PHARMACY, access);
                }]
            }
        });
    }
})();
